import { render, staticRenderFns } from "./CreditForm.vue?vue&type=template&id=f228b2bc&"
import script from "./CreditForm.vue?vue&type=script&lang=js&"
export * from "./CreditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports